import SectionCard from "@buildpy/ui/section-card";
import { pairAltOf, PAIR_STAGE_LABEL } from "@buildpy/core/modules/portfolio/pairs";
import type { PublicPortfolioImage, PublicPortfolioPair } from "@buildpy/core/modules/portfolio/public-view";
import type { PortfolioImageStage } from "@buildpy/core/modules/portfolio/types";
import PublicPhoto from "@/modules/portfolio/ui/public-photo";

const STAGES: readonly PortfolioImageStage[] = ["BEFORE", "AFTER"];

const imagesOf = (pair: PublicPortfolioPair, stage: PortfolioImageStage): PublicPortfolioImage[] =>
  stage === "BEFORE" ? pair.before : pair.after;

// 공개 상세의 「공사 전」·「공사 후」 한 줄 — 쌍 섹션과 대표 사진이 같이 쓴다.
export const PairStageLabel = ({ stage }: { stage: PortfolioImageStage }) => (
  <p className="text-xs font-medium text-muted-foreground">{PAIR_STAGE_LABEL[stage]}</p>
);

// 공개 상세의 공간별 공사 전·후 — 넓으면 좌우, 좁으면 위아래.
const PublicPairSection = ({ pairs }: { pairs: readonly PublicPortfolioPair[] }) => (
  <section className="flex flex-col gap-y-3" data-testid="public-portfolio-pairs">
    <h2 className="text-base font-semibold">공간별 공사 전·후</h2>
    {pairs.map((pair, n) => (
      <SectionCard as="div" className="flex flex-col gap-y-2" data-testid="public-portfolio-pair" key={`${pair.label}-${n}`} padding="sm">
        <h3 className="text-sm font-semibold">{pair.label}</h3>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {STAGES.map((stage) => {
            const list = imagesOf(pair, stage);
            return (
              <div className="flex flex-col gap-y-2" key={stage}>
                <PairStageLabel stage={stage} />
                {list.map((image, i) => (
                  <figure className="flex flex-col gap-y-1" key={`${image.src}-${i}`}>
                    <PublicPhoto
                      alt={pairAltOf(pair.label, stage, i, list.length)}
                      className="aspect-[4/3] w-full rounded-md"
                      src={image.src}
                    />
                    {image.caption && <figcaption className="text-xs text-muted-foreground">{image.caption}</figcaption>}
                  </figure>
                ))}
              </div>
            );
          })}
        </div>
      </SectionCard>
    ))}
  </section>
);

export default PublicPairSection;
